import React from "react";
import WorshipArticleLayout from "./WorshipArticleLayout";
import {SeoHelper} from "../../components/helpers/SeoHelper";

const WorshipSongsByScripture = () => {
    return (
        <WorshipArticleLayout
            title="Worship Songs by Bible Passage"
            subtitle="Discover worship songs that grow naturally from specific passages of Scripture, helping worship remain rooted in God’s word."
            secondaryCta={{
                title: "Looking for a gentle place to begin?",
                text: "If you are still exploring what worship means or how to begin, you may find it helpful to start with a broader reflection on worship.",
                label: "Read: I Want to Worship",
                href: "/worship/i-want-to-worship"
            }}
            primaryCta={{
                title: "Start with Scripture",
                label: "Choose a Bible Passage",
                href: "/scripture/choose-song-book"
            }}
        >
            <SeoHelper
                uri = "/worship/worship-songs-by-bible-passage"
                title = "Worship Songs by Bible Passage"
                description="Discover worship songs that grow naturally from specific passages of Scripture, helping worship remain rooted in God’s word."
            />

            {/* Intro anchor */}
            <p className="article-intro">
                Scripture has always been at the heart of the Church’s worship. Long before worship was organised around styles or traditions, God’s people responded to His word with prayer, song, and praise.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Why Begin with Scripture?</h2>
            <p>
                In the Bible, worship consistently flows from encountering God’s word. The Psalms themselves are songs shaped directly by Scripture, and the early church devoted itself to the apostles’ teaching, prayer, and praise (see{" "}<a target="biblegateway" href="https://www.biblegateway.com/passage/?search=Acts%202%3A42&version=NIV">Acts&nbsp;2:42</a>).
            </p>

            <p>
                Beginning with Scripture helps ensure that worship is a response to who God is and what He has done, rather than simply an expression of our own preferences or emotions.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">How Scripture Shapes Worship Songs</h2>
            <p>
                Many worship songs are inspired directly by specific Bible passages. Some echo the language of Scripture closely, while others reflect its themes, prayers, or declarations.
            </p>

            <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal"><li><strong>Psalms</strong> often give rise to songs of praise, lament, trust, and thanksgiving</li><li><strong>Gospel passages</strong> shape songs focused on Christ’s life, death, and resurrection</li><li><strong>Epistles</strong> inspire songs of confession, assurance, and dedication</li></ul>

            <p>
                When worship songs are chosen with Scripture in mind, the flow of worship becomes clearer and more coherent. Songs begin to feel like a natural continuation of God’s word, rather than an unrelated addition.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">From Reading to Singing</h2>
            <p>
                Starting with a Bible passage does not mean worship becomes rigid or repetitive. Instead, Scripture provides a centre — a place from which worship can grow with freedom and creativity.
            </p>

            <p>
                Many worship leaders find that reading or proclaiming Scripture first helps them recognise which themes are emerging, making it easier to select songs that respond faithfully to God’s word.
            </p>

            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">How The Worship Bible Helps</h3>
            <p>
                The Worship Bible helps connect passages of Scripture directly
                to worship songs that reflect their themes.
                Rather than beginning with a blank list of songs,
                you can begin with the text itself and discover songs
                that naturally flow from it.
            </p>

            <p>
                This approach supports worship that is both biblically grounded
                and pastorally sensitive — helping worship grow from Scripture,
                rather than forcing Scripture to fit a pre-selected set.
            </p>

        </WorshipArticleLayout>
    );
};

export default WorshipSongsByScripture;